const WINDOW_LABELS = {
  last_7_days: "Last 7 days",
  last_14_days: "Last 14 days",
  last_30_days: "Last 30 days",
  last_60_days: "Last 60 days",
  last_90_days: "Last 90 days",
  current_month: "Current month",
  previous_month: "Previous month",
  two_months_ago: "2 months ago",
  two_year_lookback: "2-year lookback",
  last_28_days: "Last 28 days",
  previous_28_days: "Previous 28 days",
  days_57_to_84: "57 to 84 days ago",
};

const SHORT_MONTH_DATE_FORMAT = {
  month: "short",
  day: "numeric",
};

const LONG_MONTH_DATE_FORMAT = {
  month: "short",
  day: "numeric",
  year: "numeric",
};

function formatDate(value, options = SHORT_MONTH_DATE_FORMAT) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", options);
}

export function getSocialWindowLabel(windowEntry = {}) {
  const key = String(windowEntry?.key || "").trim();
  const explicitLabel = String(windowEntry?.label || "").trim();
  if (WINDOW_LABELS[key]) return WINDOW_LABELS[key];
  if (explicitLabel) return explicitLabel;
  return "Selected window";
}

export function getSocialWindowRangeLabel(windowEntry = {}) {
  const startDate = windowEntry?.startDate || windowEntry?.timeframe?.window?.startDate || null;
  const endDate = windowEntry?.endDate || windowEntry?.timeframe?.window?.endDate || null;
  if (!startDate || !endDate) return "";

  const start = new Date(startDate);
  const end = new Date(endDate);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return "";

  const sameYear = start.getFullYear() === end.getFullYear();
  const sameMonth = sameYear && start.getMonth() === end.getMonth();

  if (sameMonth) {
    const month = start.toLocaleDateString("en-US", { month: "short" });
    return `${month} ${start.getDate()} - ${end.getDate()}, ${end.getFullYear()}`;
  }

  if (sameYear) {
    return `${formatDate(startDate)} - ${formatDate(endDate, LONG_MONTH_DATE_FORMAT)}`;
  }

  return `${formatDate(startDate, LONG_MONTH_DATE_FORMAT)} - ${formatDate(
    endDate,
    LONG_MONTH_DATE_FORMAT
  )}`;
}

export function getSocialWindowPrimaryLabel(windowEntry = {}, fallbackTimeframe = {}) {
  return (
    getSocialWindowLabel(windowEntry) ||
    String(fallbackTimeframe?.window?.label || "").trim() ||
    String(fallbackTimeframe?.label || "").trim() ||
    "Selected window"
  );
}

export function getSocialWindowSecondaryLabel(windowEntry = {}, fallbackTimeframe = {}) {
  const rangeLabel = getSocialWindowRangeLabel(windowEntry);
  if (rangeLabel) return rangeLabel;
  return String(fallbackTimeframe?.window?.label || fallbackTimeframe?.label || "").trim();
}

export function getSocialWindowList(data = {}) {
  const availableWindows = Array.isArray(data?.available_windows)
    ? data.available_windows
    : [];
  const windows = Array.isArray(data?.windows) ? data.windows : [];

  if (windows.length) {
    return windows.map((windowEntry) => ({
    key: windowEntry?.key || "",
    days: windowEntry?.days || null,
    startDate: windowEntry?.startDate || null,
    endDate: windowEntry?.endDate || null,
    label: getSocialWindowLabel(windowEntry),
  }));
  }

  return availableWindows.map((windowEntry) => ({
    ...windowEntry,
    label: getSocialWindowLabel(windowEntry),
  }));
}

export function getActiveSocialWindow(data = {}, activeWindowKey = null) {
  const windows = Array.isArray(data?.windows) ? data.windows : [];
  const defaultWindowKey = data?.default_window_key || null;
  if (!windows.length) return null;

  return (
    windows.find((windowEntry) => windowEntry?.key === activeWindowKey) ||
    windows.find((windowEntry) => windowEntry?.key === defaultWindowKey) ||
    windows[0] ||
    null
  );
}
